export function isObjectEmpty(obj: unknown) {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}
